import { GraphqlProvider } from '@toro/common/shared/services/new-http/providers/graphql-api.http.service';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { from, Observable } from 'rxjs';
import { ICustomerWallet } from '../../modules/customer-wallet/interfaces/customer-wallet.interface';

@Injectable({
    providedIn: 'root',
})
export class CustomerWalletService {
    constructor(private graphqlApi: GraphqlProvider) {}

    public getWallet(): Observable<ICustomerWallet | null> {
        const data = this.graphqlApi.query({
            fetchPolicy: 'network-only',
            query: gql`
            query {
                customerWallet {
                    updatedAt
                    amount
                    categories {
                        name
                        color
                        allocationAmount
                        allocationPercentage
                        groups {
                            name
                            webLink
                            mobileLink
                            products {
                                name
                                allocationAmount
                                allocationPercentage
                            }
                        }
                    }
                }
            }
        `
        }).then(
            ({ data }) => data.customerWallet || null
        ) as Promise<ICustomerWallet> | null;

        return from(data);
    }
}
